export default "__VITE_ASSET__BCw4fCp2__"